export default function TriangleExclamation({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.82536 19.5144L11.1258 4.57349C11.5068 3.88768 12.4931 3.88768 12.8742 4.57348L21.1746 19.5144C21.5449 20.1809 21.063 21 20.3005 21H3.69951C2.93703 21 2.45506 20.1809 2.82536 19.5144ZM11 16L11 9H13L13 16H11ZM11 17V19H13V17H11Z"
        fill="currentColor"
      />
    </svg>
  )
}
